import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import {Partner} from '../../../classes/partner';
import config from '../../../config';
import {PartnerType} from "../../../classes/partnerType";

@Injectable()
export class kanPartnersService {
    constructor(private http: HttpClient) {
    }

    public getPartners(filter: any = {}): Promise<Partner[]> {
        return new Promise((resolve, reject) => {
            // let filter = {
            //     where: {
            //         active: true
            //     },
            //     include: ['type']
            // };
            let params = new HttpParams().set('filter', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/partners`, {params: params})
                .toPromise()
                .then((response: any) => {
                    let partners = response.map((item) => {
                        // item.birthday = item.birthday ? new Date(item.birthday) : null;
                        return item;
                    });
                    resolve(partners as Partner[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public countPartners(filter: any = {}): Promise<number> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('where', JSON.stringify(filter));
            this.http.get(`${config.apiRootUrl}/api/partners/count`, {params: params})
                .toPromise()
                .then((respone: any) => {
                    resolve(respone.count as number);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public addPartner(partner: Partner): Promise<Partner> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/partners`, partner)
                .toPromise()
                .then((response: any) => {
                    resolve(response as Partner);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public updatePartner(partner: Partner): Promise<Partner> {
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/partners/${partner.id}`, partner)
                .toPromise()
                .then((response: any) => {
                    resolve(response as Partner);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public removePartner(partner: Partner): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/partners/${partner.id}/deactivate`, {})
                .toPromise()
                .then((response: any) => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public isEmailUsed(email: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/partners/usedemail`, {email: email})
                .toPromise()
                .then((respone: any) => {
                    resolve(respone.data as boolean);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    public getPartnerTypes(): Promise<PartnerType[]> {
        return new Promise((resolve, reject) => {
            this.http.get(`${config.apiRootUrl}/api/partnerTypes`)
                .toPromise()
                .then((response: any) => {
                    resolve(response as PartnerType[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public addPartnerType(partnerType: PartnerType): Promise<PartnerType[]> {
        return new Promise((resolve, reject) => {
            this.http.post(`${config.apiRootUrl}/api/partnerTypes`, partnerType)
                .toPromise()
                .then((response: any) => {
                    resolve(response as PartnerType[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    public updatePartnerType(partnerType: PartnerType): Promise<PartnerType[]> {
        return new Promise((resolve, reject) => {
            this.http.patch(`${config.apiRootUrl}/api/partnerTypes/${partnerType.id}`, partnerType)
                .toPromise()
                .then((response: any) => {
                    resolve(response as PartnerType[]);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/partners.ts